import { Component } from 'react';
import CoreComponent from '../../../../services/engines/CoreComponent';
import { Box, Typography } from '@mui/material';

import './FormConfigItemRow.css';

export default function FormConfigItemRow({ item, isSelected, onSelect }) {
    return (
        <Box
            //
            // sx={{ display: 'block', width: '100%' }}
            id={`FormConfigItemRow-${item.rk}`}
            className="entry-row-wrapper"
        >
            <Box
                id={`entry-row-${item.rk}`}
                className={`entry-row-card ${isSelected ? 'entry-row-card--selected' : ''}`}
                onClick={() => onSelect(item)}
            >
                <Typography
                    className={`entry-row-title ${isSelected ? 'entry-row-title--selected' : ''}`}
                    sx={item.stateId === 1 ? { textDecoration: 'line-through', opacity: 0.5 } : {}}
                >
                    {item.title}
                </Typography>

                <Typography
                    className={`entry-row-title ${isSelected ? 'entry-row-title--selected' : ''}`}
                    sx={item.stateId === 1 ? { textDecoration: 'line-through', opacity: 0.5 } : {}}
                >
                    StateId: {item.stateId}
                </Typography>
            </Box>
        </Box>
    );
}
